<template>
  <v-col cols="12">
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Event templates</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddSeriesEventTemplate(serie)">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels>
      <v-expansion-panel v-for="(eventTemplate, index) in serie.eventTemplates" :key="index">
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-fade-transition leave-absolute>
              <v-row no-gutters>
                <v-col cols="3">
                  <v-chip v-if="open" key="0" small color="primary"> {{ eventTemplate.id }} </v-chip>
                  <v-chip v-else key="1" small color="primary"> {{ eventTemplate.id }} </v-chip>
                </v-col>

                <v-col cols="4">
                  <v-chip small color="primary">
                    {{ eventTemplate.series.id }}
                  </v-chip>
                </v-col>

                <v-spacer> </v-spacer>
                <v-col cols="1">
                  <v-btn icon>
                    <v-icon @click="onDeleteSeriesEventTemplate(index)">mdi-close-thick</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-fade-transition>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p></p>

          <v-checkbox
            :input-value="eventTemplate.series && eventTemplate.series.shots != null"
            label="Specify shots"
            @click="createOrRemoveSpecifiedShots(eventTemplate)"
          ></v-checkbox>

          <v-combobox v-model="eventTemplate.id" :items="getEventClass()" label="Name" chips></v-combobox>
          <p></p>
          <v-row>
            <v-col cols="8" md="7" lg="9">
              <v-combobox
                :value="eventTemplate.series && eventTemplate.series.id"
                label="Serie"
                :items="getEventTemplateAll()"
                @change="updateSerieStructure($event, eventTemplate)"
                chips
              ></v-combobox>
            </v-col>
            <v-col style="margin-left: 10px;" class="d-flex align-center">
                <v-row no-gutters align="center" style="padding: 0px;">
                <div style="margin-top: 10px;" v-if="eventTemplate.series.shots != null && eventTemplate.series != null">
                  <v-row align="center">
                    <v-text-field
                      v-if="eventTemplate.series.shots"
                      class="shot-input centered-input"
                      v-model.number="eventTemplate.series.shots.from"
                      label="shot"
                      type="number"
                      :rules="(eventTemplate.series.shots != null && [...rules.required, ...rules.positiveNumber]) || []"
                    />
                    <span style="margin: 10px;">to</span>
                    <v-text-field
                      v-if="eventTemplate.series.shots"
                      class="shot-input centered-input"
                      v-model.number="eventTemplate.series.shots.to"
                      label="shot"
                      type="number"
                      :rules="(eventTemplate.series.shots != null && [...rules.required, ...rules.positiveNumber]) || []"
                    />
                  </v-row>
                </div>
              </v-row>
              </v-col>
          </v-row>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
  import * as helpers from '../../shootingProgramHelpers.js';
  export default {
    name: 'EditSeriesEventTemplatePanel',
    props: {
      serie: Object,
    },
    data() {
      return {
        rules: {
          required: [(v) => !!v || 'Number is required'],
          positiveNumber: [(v) => /^\d+$/.test(v) || 'Must be a positive integer'],
        },
      }
    },
    methods: {
      updateSerieStructure(serieId, eventTemplate){
        if (typeof serieId === 'string') {
          eventTemplate.series = {
            ...eventTemplate.series,
            id: serieId
          }
        }
      },
      createOrRemoveSpecifiedShots(eventTemplate) {
        if(eventTemplate.series.shots == null){
          //Add shots if specifying.
          eventTemplate.series = {
            id: eventTemplate.series ? eventTemplate.series.id : "",
            shots: {
              from: null,
              to: null,
            },
          }
        } else {
            //remove shots if not specifying.
            eventTemplate.series = 
            {
              id: eventTemplate.series.id
            }
        }
      },
      getEventClass() {
        return helpers.getEventClass();
      },

      getEventTemplateAll() {
        return helpers.getEventTemplateAll();
      },
      onAddSeriesEventTemplate(series) {
        series.eventTemplates.push({
          id: '',
          series: '',
        });
      },
      onDeleteSeriesEventTemplate(index) {
        this.serie.eventTemplates.splice(index, 1);
      },
    },
  };
</script>

<style scoped>
  .shot-input {
    max-width: 50px;
    min-width: 50px;
  }

  .centered-input ::v-deep input {
   text-align: center;
  }
</style>
